module.exports = __webpack_public_path__ + "media/flags/eu-a178c2d5.svg";